import React, { useState, useEffect } from 'react'

import useModal from 'hook/useModal'
// css
import 'assets/style/common.scss'

// elements
import { SearchBar, Text, ListTitle, Line, InputRadio, Label, TextInput, BottomButton } from 'components'
import { useAddress } from 'api/common/address-fetch'

// 주소 검색
function AddressSearch({ keywords = '', ok = () => {} }) {
  const { alertModal, closeModal } = useModal()
  const [isInit, setIsInit] = useState(false)
  const [selected, setSelected] = useState(-1)
  const [addressDtil, setAddressDtil] = useState('')

  const [list, setList] = useState([])
  const [queryOptions, setQueryOptions] = useState(keywords)

  const { data, isSuccess } = useAddress(queryOptions, isInit)
  //   const { data, isSuccess } = useCommonSite(queryOptions, isInit)

  useEffect(() => {
    if (isSuccess) {
      const { juso, common } = data.results

      if (!juso) {
        alertModal(common.errorMessage)
        return
      }

      if (juso.length == 0) {
        alertModal('검색결과가 없습니다.')
        return
      }

      setList(juso)
    }
  }, [data])

  return (
    <main className="wrapper">
      {/* todo: 팝업 헤더 */}
      <section>
        <Text text="주소검색" className="mb16 f-16 f-bold c-3 " />
        <SearchBar
          goSearch={(value) => {
            if (value == '') {
              alertModal('검색어를 입력해주세요.')
              return
            }
            console.log('검색', value)
            setSelected(-1)
            setQueryOptions(value)
            setIsInit(true)
          }}
        />

        <ListTitle title="검색결과" count={list.length} className="wrapper mt16" />

        <Line size="1" color="gray" />

        <div className="mt16">
          <ul
            className="basic-list scrollable-y"
            style={{
              maxHeight: '300px',
            }}
          >
            {list.map((item, index) => (
              <li className="flex flex-1" key={item.zipNo + index}>
                <InputRadio
                  checked={selected == index}
                  onClick={() => {
                    // ok(item)
                    setSelected(index)
                  }}
                  title={
                    <div className="flex-col flex-1 gap-4">
                      <Text className="f-14 mono-6" text={`${item.roadAddr}[${item.zipNo}]`} />
                      <Text className="f-14 mono-3" text={`${item.jibunAddr}`} />
                    </div>
                  }
                  name="r1"
                  className="flex1"
                />
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="mt24">
        <Label text="상세주소" />
        <TextInput
          className="mt8"
          value={addressDtil}
          placeholder="상세주소를 입력하세요."
          onChange={(e) => {
            setAddressDtil(e.target.value)
          }}
        />
      </section>

      <BottomButton
        data={[{ title: '확인', color: 'primary' }]}
        onClick={() => {
          if (selected == -1) {
            alertModal('주소를 선택해주세요.')
            return
          }
          ok({
            ...list[selected],
            dtlAddr: addressDtil,
          })
          closeModal()
        }}
      />
    </main>
  )
}

export default AddressSearch
